"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _reduxForm = require("redux-form");
var _RecentActivityComponent = _interopRequireDefault(require("./RecentActivityComponent"));
var _resize = _interopRequireDefault(require("../../hocs/resize"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var RecentActivityComponentForm = (0, _reduxForm.reduxForm)({
  form: 'recent-activity',
  destroyOnUnmount: false,
  initialValues: {
    type: 'all',
    startDate: undefined,
    endDate: undefined
  }
})(_RecentActivityComponent["default"]);
var _default = exports["default"] = (0, _reactRedux.connect)()((0, _resize["default"])(RecentActivityComponentForm));